/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Fields_NoneInputs */

const en_endpoint_fields_none = /** @type {(inputs: Endpoint_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fields published for this endpoint.`)
};

const zh_hans1_endpoint_fields_none = /** @type {(inputs: Endpoint_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个接口没有公开的字段。`)
};

const pt_br2_endpoint_fields_none = /** @type {(inputs: Endpoint_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum campo publicado para este endpoint.`)
};

const es_endpoint_fields_none = /** @type {(inputs: Endpoint_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este endpoint no tiene campos publicados.`)
};

const fr_endpoint_fields_none = /** @type {(inputs: Endpoint_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun champ publié pour cet endpoint.`)
};

const de_endpoint_fields_none = /** @type {(inputs: Endpoint_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diesen Endpoint sind keine Felder veröffentlicht.`)
};

const ru_endpoint_fields_none = /** @type {(inputs: Endpoint_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для этого эндпоинта не опубликовано полей.`)
};

const it_endpoint_fields_none = /** @type {(inputs: Endpoint_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun campo pubblicato per questo endpoint.`)
};

/**
* | output |
* | --- |
* | "No fields published for this endpoint." |
*
* @param {Endpoint_Fields_NoneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_fields_none = /** @type {((inputs?: Endpoint_Fields_NoneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Fields_NoneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_fields_none(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_fields_none(inputs)
	if (locale === "es") return es_endpoint_fields_none(inputs)
	if (locale === "fr") return fr_endpoint_fields_none(inputs)
	if (locale === "de") return de_endpoint_fields_none(inputs)
	if (locale === "ru") return ru_endpoint_fields_none(inputs)
	if (locale === "it") return it_endpoint_fields_none(inputs)
	return en_endpoint_fields_none(inputs)
});